// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Lookup } from './lookup';
import { Meeting } from './meeting';
import { MeetingAttendanceResolution } from './meeting-attendance-resolution';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class MeetingResolution extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  meetingResolutionId!: number;
  createdBy!: string;
  createdDate!: Date;
  description!: string;
  meetingId!: number;
  resolutionTypeLookupId!: number;
  status?: number;
  ts!: string;
  uid!: string;
  updatedBy!: string;
  updatedDate!: Date;
  webFlags?: number;
  meeting!: Meeting;
  meetingAttendanceResolutions!: MeetingAttendanceResolution[];
  resolutionTypeLookup!: Lookup;
}

